import { render, staticRenderFns } from "./RewardsBox.vue?vue&type=template&id=36ca542c&scoped=true&lang=pug"
import script from "./RewardsBox.vue?vue&type=script&lang=js"
export * from "./RewardsBox.vue?vue&type=script&lang=js"
import style0 from "./RewardsBox.vue?vue&type=style&index=0&id=36ca542c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca542c",
  null
  
)

export default component.exports